import WatchlistPanel from './WatchlistPanel';

export default WatchlistPanel;
